const mapState = {
  address: "",
  errorMessage: "",
  isGeocoding: false,
  center: {
    lat: -33.4426907,
    lng: -70.63202949999999,
  },
  zoom: 18,
  directionMetadata: {
    country: "",
    region: "",
    province: "",
    commune: "",
    street: "",
    number: "",
    typeStreet: "",
    town: "",


  },
  params: { v: "3.exp", key: "AIzaSyC6j1OfriwrK8nrsYep5weTfn7yyXaSzlY" },
};
export default mapState;
